var map = {
	"./tcrs_en_EN/background_gradient.png": 54972,
	"./tcrs_en_EN/header_gradient.png": 7420,
	"./tcrs_en_EN/header_logo_narrow.png": 71889,
	"./tcrs_en_EN/header_logo_wide.svg": 10790,
	"./tcrs_en_EN/login_logo.svg": 18938,
	"./troy_de_DE/background_gradient.png": 55233,
	"./troy_de_DE/header_gradient.png": 89841,
	"./troy_de_DE/header_logo_narrow.png": 63747,
	"./troy_de_DE/header_logo_wide.svg": 72630,
	"./troy_de_DE/login_logo.svg": 68250,
	"./troy_nl_NL/background_gradient.png": 46561,
	"./troy_nl_NL/header_gradient.png": 84208,
	"./troy_nl_NL/header_logo_narrow.png": 15480,
	"./troy_nl_NL/header_logo_wide.svg": 86940,
	"./troy_nl_NL/login_logo.svg": 2666
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87467;